const DEFAULT_MAP_CENTER: [number, number] = [32.68, 51.68];
const DEFAULT_MAP_ZOOM = 9;
const DEFAULT_PICKER_ZOOM = 15;
const DEFAULT_MAP_TYPE = "dreamy";
const SEARCH_DEBOUNCE_MS = 400;
const API_TIMEOUT_MS = 10000;

export interface MapClientConfig {
  apiKey: string;
  mapType: string;
  defaultCenter: [number, number];
  defaultZoom: number;
  isConfigured: boolean;
}

export const mapConfig = {
  defaultCenter: DEFAULT_MAP_CENTER,
  defaultZoom: DEFAULT_MAP_ZOOM,
  pickerZoom: DEFAULT_PICKER_ZOOM,
  defaultMapType: DEFAULT_MAP_TYPE,
  searchDebounceMs: SEARCH_DEBOUNCE_MS,
  apiTimeoutMs: API_TIMEOUT_MS,
  searchEndpoint: "Map/Geocoding/Search",
  reverseGeocodeEndpoint: "Map/Geocoding/Reverse",
  clientConfigEndpoint: "Map/Geocoding/GetClientConfig",
} as const;

export function normalizeMapClientConfig(raw: Record<string, unknown> | null | undefined): MapClientConfig {
  const center = raw && Array.isArray(raw.defaultCenter) ? raw.defaultCenter : DEFAULT_MAP_CENTER;

  return {
    apiKey: String(raw?.apiKey ?? ""),
    mapType: String(raw?.mapType ?? DEFAULT_MAP_TYPE),
    defaultCenter: [
      Number(center[0] ?? DEFAULT_MAP_CENTER[0]),
      Number(center[1] ?? DEFAULT_MAP_CENTER[1]),
    ],
    defaultZoom: Number(raw?.defaultZoom ?? DEFAULT_MAP_ZOOM),
    isConfigured: Boolean(raw?.isConfigured),
  };
}
